
import {useContext} from "react";
import store from "../store"

export function useToast(){
    const {showMessage,showError} = useContext(store);
    const toast = {
        success:showMessage,
        error:showError
    }
    return toast;
}
export default useToast;